module.exports = __webpack_public_path__ + "static/media/photo-video.e8eeca2d.svg";